import logo from "../assets/inspecar-logo.png";

export default function Logo({ dark = false, withTagline = true, size = "md" }) {
  const dims = size === "sm" ? "w-9 h-9" : "w-11 h-11";
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <img src={logo} alt="Inspecar logo" className={`${dims} object-contain shrink-0`} />
      <div className="leading-tight">
        <p className={`font-extrabold tracking-tight ${size === "sm" ? "text-lg" : "text-2xl"} ${dark ? "text-white" : "text-slate-900"}`}>
          Inspecar
        </p>
        {withTagline && (
          <p className="text-[9px] font-medium text-slate-400">Inspeksi Mobil, Keputusan Lebih Pasti</p>
        )}
      </div>
    </div>
  );
}
